__turbopack_context__.v({
  "active": "NavToggle-module__yyUFhW__active",
  "icon": "NavToggle-module__yyUFhW__icon",
  "link": "NavToggle-module__yyUFhW__link",
  "linkGroup": "NavToggle-module__yyUFhW__linkGroup",
});
